// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_30d8c2c8","outerContainer":"_194daff5","secondaryToolbar":"ff4c6b73","doorHangerRight":"_179bb043","toolbarContainer":"c7df8881","toolbarViewerMiddle":"c994f814","progressBar":"a66d9e5b","back-to-application":"cfad9f86","root":"_04d40ac7","viewAttachmentWrapper":"_11861319","documentWrapper":"_8eac03b1","fileInfoWrapper":"_215aac13","icon":"_5be4eecb","removeIcon":"a003f3b6","fileTitle":"_2888f4b7","fileCategory":"_7258291c","uploadFileTitle":"_2ada7784"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/VisitDocuments/ViewDocuments/index.styl
// module id = 4992
// module chunks = 39